import TomSelect from 'tom-select';

/**
 * Durchsuchbare Auswahl (tom-select) für <x-ui.select searchable>.
 * Wert wird ohne eigenen Request gesetzt (live: false) und mit der nächsten
 * Aktion übertragen – weniger Requests, weniger WAF-Angriffsfläche.
 */
export function registerSelect(Alpine) {
    const baseOptions = (placeholder) => ({
        create: false,
        allowEmptyOption: true,
        maxOptions: 300,
        placeholder,
        render: {
            no_results: () => '<div class="no-results">Keine Treffer</div>',
            option_create: (data, escape) => `<div class="create">„${escape(data.input)}“ neu anlegen …</div>`,
        },
        onDropdownClose() {
            window.nnSelectClosedAt = Date.now();
        },
    });

    Alpine.data('nnSelect', ({ model, live = false, create = null, placeholder = '' }) => ({
        ts: null,

        init() {
            const select = this.$el.querySelector('select');
            const options = baseOptions(placeholder);

            if (create) {
                options.create = (input, callback) => {
                    this.$wire.$call(create, input).then((result) => {
                        if (result && result.value !== undefined) {
                            callback({ value: String(result.value), text: result.text });
                        } else {
                            callback();
                        }
                    });
                };
            }

            this.ts = new TomSelect(select, options);
            this.sync(this.$wire.get(model));

            this.ts.on('change', (value) => {
                const current = this.$wire.get(model);
                const next = value === '' ? null : value;
                if (String(current ?? '') !== String(next ?? '')) {
                    this.$wire.$set(model, next, live);
                    this.$el.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        },

        sync(value) {
            if (!this.ts) return;
            const next = value === null || value === undefined ? '' : String(value);
            if (this.ts.getValue() !== next) this.ts.setValue(next, true);
        },

        destroy() {
            this.ts?.destroy();
        },
    }));
}
